import { shallowRef } from 'vue';

const googlePlaceCacheSize = 4;
export const googlePlaceCache = shallowRef<google.maps.places.PlaceResult[]>([]);
export const updateGooglePlaceCache = (place: google.maps.places.PlaceResult) => {
  if (!place?.place_id) {
    return;
  }

  const cache = googlePlaceCache.value;
  const existingI = cache.findIndex((pl) => pl.place_id === place.place_id);

  // already top result
  if (existingI === 0) {
    return;
  }

  // remove from old index
  if (existingI > 0) {
    cache.splice(existingI, 1);
  }

  // add to top
  cache.unshift(place);

  googlePlaceCache.value = cache.slice(0, googlePlaceCacheSize);
};
